import { Button, Flex } from 'antd';
import styles from '../index.module.scss';
import { IconCheck } from '../../../../../Common/Icon';

const SurveySuccess = ({ viewResults }: { viewResults: () => void }) => {
  return (
    <div className={styles.content}>
      <Flex justify="center">
        <IconCheck />
      </Flex>
      <p className={styles.question}>Thanks for taking the quiz!</p>
      <p className={styles.subQuestion}>
        <div>
          Check out how others answered below and see how your thoughts stack
          up.
        </div>
        <div>
          Explore the results and find out what others think about tipping!
        </div>
      </p>

      <Flex justify="center" style={{ marginTop: 40 }}>
        <Button type="primary" className={styles.submit} onClick={viewResults}>
          View Results
        </Button>
      </Flex>
    </div>
  );
};

export default SurveySuccess;
